var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAviationPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:5.58px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.39,45.72l58.39,40.36,30.37-14.93c15.88-9,33.67.61,10.11,16l-31.48,17.2-3.3,71.3-18.77,9.65-11.64-65L79.64,137.1l-3.7,26.81-9.84,4.85-6.22-33.29-22.35-25.1L47,105.48l23.58,13.35L102.7,103,59.21,54.79Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAviationPlane);
export default __webpack_public_path__ + "static/media/AVIATION_PLANE.09b4c887fc63e472975cf26e34fe5a22.svg";
export { ForwardRef as ReactComponent };